import * as Cookies from "es-cookie";

// The logged-in user's assignment is stored at login as comma-separated id cookies
// (see pages/Login.jsx, RoleLogin.jsx). A module must show that user ONLY the
// records matching them.
//
// An EMPTY / MISSING cookie means the dimension was never assigned → unrestricted.
// Never lock a user out of a dimension the admin didn't configure.
const readIdCookie = (name) => {
  const raw = Cookies.get(name);
  if (!raw) return [];

  // Cookie always contains comma-separated numeric IDs (e.g. "10,12,15")
  return String(raw)
    .split(",")
    .map(id => id.trim())
    .filter(id => id);
};

export const getAuthorizedBranchIds = () => {
  const ids = readIdCookie("branch_id");
  if (ids.length > 0) return ids;
  return readIdCookie("branch_ids");
};

export const getAuthorizedClassIds = () => {
  const idsFromClassIds = readIdCookie("class_ids");
  if (idsFromClassIds.length > 0) return idsFromClassIds;

  const idsFromClassId = readIdCookie("class_id");
  if (idsFromClassId.length > 0) return idsFromClassId;

  return readIdCookie("classid");
};

export const getAuthorizedSectionIds = () => {
  const ids = readIdCookie("section_ids");
  if (ids.length > 0) return ids;
  return readIdCookie("section_id");
};

export const getAuthorizedSubjectIds = () => {
  const ids = readIdCookie("subject_ids");
  if (ids.length > 0) return ids;
  return readIdCookie("subject_id");
};

// Keep only the rows whose `idKey` is in `allowedIds`. An empty `allowedIds`
// returns the list untouched, so an unassigned dimension keeps existing behaviour.
export const filterByAuthorizedIds = (list, allowedIds, idKey = "id") => {
  const rows = list || [];
  if (!allowedIds || !allowedIds.length) return rows;
  const allow = new Set(allowedIds.map(String));
  return rows.filter(row => row && allow.has(String(row[idKey])));
};
